import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import './util/rem.js'

import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload);

//或者自定义配置插件
Vue.use(VueLazyload, {
	preLoad: 1.3,
	attempt: 1
})


// 引入路由
import router from './router'

import {
	importManager
}
from 'less'

new Vue({
	render: h => h(App),
	router
}).$mount('#app')
